import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { VivaWarningPopupComponent } from './viva-warning-popup.component';

@NgModule({
  declarations: [
    VivaWarningPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    VivaWarningPopupComponent
  ]
})
export class  VivaWarningPopupModule { }
